<div class="container">
    <h1>{{ title }}</h1>
    <div class="items-wrapper">
        @for (item of items; track $index) {
            <app-list-element
                [itemId]="item.id"
                [title]="item.title"
                [subtitle]="item.subtitle"
                [link]="item.link"
                [canRemoveItem]="item.canRemoveItem"
                [isFavorite]="item.isFavorite"
                [isScheduleItem]="item.isScheduleItem"
                [schedulerStatusId]="item.schedulerStatusId"
                [scheduleTooltip]="item.scheduleTooltip"
                (isFavoriteChange)="onFavoriteChange(item)"
                (removeElementRequest)="onRemoveItem($event)"
                [description]="item.description"
            ></app-list-element>
        }
    </div>
</div>
